exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination-wrapper .results[data-v-668e7109]{float:left\n}\n.pagination-wrapper .results p[data-v-668e7109]{font-size:11.5px;margin:6px 0 0\n}\n.pagination-wrapper nav[data-v-668e7109]{float:right;height:27px\n}\n.pagination-wrapper nav .pagination[data-v-668e7109]{margin:0\n}\n.pagination-wrapper nav li.no-link span[data-v-668e7109]:hover{background-color:#fff\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-668e7109","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pagination/Pagination.vue
// module id = vJqr
// module chunks = 21